/** @jsx jsx */
import React from 'react';
import { jsx } from '@compiled/react';
import { Text } from '@atlaskit/primitives/compiled';
import { useIntl } from '@atlassian/jira-intl';
import messages from '../messages.tsx';
import { useCommentContext } from './CommentContextProvider.tsx';
import CommentSubtext from './CommentSubtext.tsx';

const CommentSavingIndicator = () => {
	const { formatMessage } = useIntl();
	const { isSaving } = useCommentContext();

	if (!isSaving) {
		return null;
	}

	return (
		<CommentSubtext>
			<Text>{formatMessage(messages.saving)}</Text>
		</CommentSubtext>
	);
};
export default CommentSavingIndicator;
